import styled from '@emotion/styled';
import { Button } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledLoginFormContainer = styled.div`
  width: 731px;

  border-radius: 0 15px 15px 0;
  margin: 0 auto !important;
  text-align: center;

  @media (max-width: 1190px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 1023px) {
    width: 100%;
    padding: 20px;
    border-radius: 0;
  }
`;
export const StyledInput = styled.input<{ borderColor?: string; color?: string; focusColor?: string }>`
  border: solid 2px ${({ borderColor }) => borderColor};
  border-radius: 4px;
  height: 96px;
  flex-grow: 0;
  opacity: 0.9;
  width: 731px;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  color: ${({ color }) => color};

  :focus {
    outline: none;
    border: solid 2px ${({ focusColor }) => focusColor};
  }

  :active {
    border: solid 2px ${({ focusColor }) => focusColor};
  }
  @media (max-width: 1190px) {
    width: 100%;
  }

  @media (max-width: 1023px) {
    width: 100%;
    height: 80px;
    font-size: 24px;
    margin: 0 auto;
  }
`;

export const StyledInputAccessCode = styled.input<{ borderColor?: string; color?: string; focusColor?: string }>`
  border: solid 2px ${({ borderColor }) => borderColor};
  border-radius: 4px;
  height: 96px;
  flex-grow: 0;
  opacity: 0.9;
  width: 731px;
  font-size: 45px;
  font-weight: 600;
  letter-spacing: 10px;
  text-align: center;
  color: ${({ color }) => color};

  :focus {
    outline: none;
    border: solid 2px ${({ focusColor }) => focusColor};
  }

  :active {
    border: solid 2px ${({ focusColor }) => focusColor};
  }

  @media (max-width: 1190px) {
    width: 100%;
  }
  @media (max-width: 1023px) {
    width: 100%;
    height: 80px;
    font-size: 24px;
    letter-spacing: 6px;
    margin: 0 auto;
  }
`;

export const StyledError = styled.span`
  max-width: 800px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.33;
  letter-spacing: normal;
  text-align: right;
  padding-left: 5px;
  text-transform: uppercase;
  @media (max-width: 1023px) {
    line-height: 1.33;
    max-width: 600px;
  }
`;

export const StyledErrorContainer = styled.div`
  text-align: right;
  color: ${COLORS.venetianRed};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const StyledHeader = styled.div`
  font-size: 72px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.02;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.seaBlue};
  padding-top: 62px;
  margin-bottom: -20px;
  @media (max-width: 1023px) {
    padding-top: 62px;
    font-size: 52px;
    line-height: 0.7;
  }
`;

export const StyledIcon = styled.span`
  margin: 0 5px;
`;

export const StyledLabel = styled.div`
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  display: block;
  text-align: center;
  color: ${COLORS.blackOlive};
`;

export const StyledCheckBoxText = styled.span`
  font-size: 11.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.blackOlive};
  padding: 0 5px;
  @media (max-width: 1023px) {
    font-size: 11.5px;
    line-height: 1.5;
  }
`;

export const StyledExplanation = styled.div`
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.33;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.blackOlive};
  @media (max-width: 1023px) {
    line-height: 1.33;
  }
`;

export const StyledButton = styled(Button)`
    width: 92px;
    height: 42px;
    margin: 28px auto!important;
    border:  1px solid ${COLORS.seaBlue};
    border-radius: 8px;
    color: ${COLORS.white} !important;
    font-size: 16px;
    font-weight: bold;
    :disabled,
    [disabled]{
    cursor: not-allowed !important;
    opacity: 0.5 !important;
    border: none !important
    color: ${COLORS.white} !important;
      }
      @media (max-width: 1023px) {
  margin: 20px auto 0px !important;
  }
    `;

export const StyledCheckBoxContainer = styled.div`
  height: 42px;
  max-width: 731px;
  margin: 0 auto;
  background-color: ${COLORS.gray95};
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 5px;
    height: auto;
    flex-wrap: nowrap;
  }
`;

export const StyledSpace = styled.div`
  padding: 12px 0 12px;
`;

export const StyledTooltip = styled.div`
  fontsize: 10px;
  width: 160px;
  box-shadow: -4px 4px 4px 4px rgba(0, 0, 0, 0.15);
  padding: 6px;
  margin: 0px;
`;

export const StyledPLeft = styled.p`
  text-align: 'left';
`;

export const StyledInputCheckBox = styled.input`
  background-color: ${COLORS.seaBlue};
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
